import { useContext } from 'react';

import { NotifyOverflowContext } from '../context/NotifyOverflowContext';

export const useNotifyOverflowContext = () => {
  const context = useContext(NotifyOverflowContext);

  if (!context) throw new Error('NotifyOverflowContext must be used within a provider');

  return context;
};
